module.exports = __webpack_public_path__ + "static/media/qts.997469ed.png";